import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.elementType), {
    class: "nmm_title",
    style: _normalizeStyle(_ctx.loadedInStorybook ? ' font-size: 7vw' : ''),
    ref: "titleElement"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "nmm_title__line_container",
          key: `display-type-line--${index}`
        }, [
          _createElementVNode("span", {
            class: "nmm_title__line_mask",
            style: _normalizeStyle(`height: ${line.maskHeight}%;`)
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["nmm_title__line", `nmm_title__line--${index}`]),
              style: _normalizeStyle(`margin-left: ${line.indent}em`)
            }, _toDisplayString(line.text), 7)
          ], 4)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style"]))
}